export default {
  name: 'step-up-question-check',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      questions: '',
      getQuestionsEnd: false
    }
  },
  computed: {
  },
  methods: {
    async search () {
      let data = {
        division: this.$route.query.division
      }
      let res = await this.$store.dispatch('GET_QUESTIONS', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.questions = res.questions
      this.getQuestionsEnd = true
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/scripts/step-up-question-check.js